import type { TreeData } from '../../../types'

// custom ast plugin for scroll sync
export const createCustomPlugin = (
  treeDataRef?: React.RefObject<TreeData | null>,
  onTreeReady?: () => void
) => {
  return () => {
    return (tree: TreeData) => {
      if (treeDataRef?.current !== undefined) {
        treeDataRef.current = tree
        onTreeReady?.()
      }
    }
  }
}
